module.exports = __webpack_public_path__ + "static/media/zuzia.64c37f8f.jpg";